<section class="ministry-transfer-page">
  <header class="page-header">
    <button mat-icon-button routerLink="/units" matTooltip="Volver a comunidades">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <mat-icon class="header-icon">assignment_ind</mat-icon>

    <div class="header-text">
      <h1>Pases ministeriales</h1>
      <p>Seguimiento de solicitudes de activación ministerial entre comunidades.</p>
    </div>
  </header>

  <mat-card class="requests-card">
    <div class="toolbar">
      <mat-button-toggle-group
        [value]="statusFilter"
        appearance="standard"
        (valueChange)="onStatusFilterChange($event)">
        <mat-button-toggle value="Pending">Pendientes</mat-button-toggle>
        <mat-button-toggle value="Approved">Aprobados</mat-button-toggle>
        <mat-button-toggle value="Rejected">Rechazados</mat-button-toggle>
        <mat-button-toggle value="Cancelled">Cancelados</mat-button-toggle>
        <mat-button-toggle value="All">Todos</mat-button-toggle>
      </mat-button-toggle-group>

      <div class="toolbar-actions">
        <span class="count">{{ requests.length }}</span>
        <button mat-icon-button (click)="loadRequests()" matTooltip="Actualizar">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="errorMessage && !isLoading" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <div *ngIf="!isLoading && !errorMessage && requests.length === 0" class="empty-state">
      <mat-icon>assignment_turned_in</mat-icon>
      <p>No hay pases ministeriales para el filtro seleccionado.</p>
    </div>

    <div class="table-wrapper" *ngIf="!isLoading && !errorMessage && requests.length > 0">
      <table mat-table [dataSource]="requests" class="requests-table">

        <ng-container matColumnDef="requestedDate">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let row">
            {{ row.requestedDate | date:'dd/MM/yyyy':'UTC' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="person">
          <th mat-header-cell *matHeaderCellDef>Persona</th>
          <td mat-cell *matCellDef="let row">
            <button mat-button class="link-button" (click)="navigateToPerson(row.personId)">
              {{ getPersonName(row) }}
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="ministry">
          <th mat-header-cell *matHeaderCellDef>Ministerio</th>
          <td mat-cell *matCellDef="let row">
            {{ row.ministryName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="route">
          <th mat-header-cell *matHeaderCellDef>Origen / destino</th>
          <td mat-cell *matCellDef="let row">
            <div class="route-cell">
              <button mat-button class="link-button" (click)="navigateToUnit(row.fromOrganizationUnitId)">
                {{ row.fromOrganizationUnitName }}
              </button>
              <mat-icon>arrow_forward</mat-icon>
              <button mat-button class="link-button" (click)="navigateToUnit(row.toOrganizationUnitId)">
                {{ row.toOrganizationUnitName }}
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-badge" [ngClass]="'status-' + row.status.toLowerCase()">
              {{ getStatusLabel(row.status) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="resolvedDate">
          <th mat-header-cell *matHeaderCellDef>Resolución</th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row.resolvedDate; else noResolvedDate">
              {{ row.resolvedDate | date:'dd/MM/yyyy':'UTC' }}
            </span>
            <ng-template #noResolvedDate>
              <span class="no-value">-</span>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef>Notas</th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row.resolutionNotes; else noNotes">{{ row.resolutionNotes }}</span>
            <ng-template #noNotes>
              <span class="no-value">-</span>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="actions-cell">
            <ng-container *ngIf="row.status === 'Pending'; else noActions">
              <button
                mat-icon-button
                color="primary"
                [disabled]="resolvingRequestId === row.id"
                (click)="approve(row)"
                matTooltip="Aprobar pase ministerial">
                <mat-icon>check</mat-icon>
              </button>
              <button
                mat-icon-button
                color="warn"
                [disabled]="resolvingRequestId === row.id"
                (click)="reject(row)"
                matTooltip="Rechazar pase ministerial">
                <mat-icon>close</mat-icon>
              </button>
            </ng-container>
            <ng-template #noActions>
              <span class="no-value">-</span>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-card>
</section>
